module.exports = __webpack_public_path__ + "static/media/icon_counterargument.f4062071.svg";


//////////////////
// WEBPACK FOOTER
// ./client/modules/ui/assets/icon_counterargument.svg
// module id = 1253
// module chunks = 0